/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/anchor-has-content */
import React from "react";
import Question from "@components/refactored-survey/question-types/Question";
import CheckboxWithOtherQuestion, {
  CheckboxWithOtherQuestionDefinition,
} from "../../question-types/CheckboxWithOtherQuestion";
import { Text } from "src/components/core/Text";
import {
  questionTitle,
  questionOptions,
} from "@components/refactored-survey/question-types/Question.module.less";
import {
  CustomQuestionDefinition,
  registerQuestion,
} from "../../QuestionDefinition";

import { SurveyAnswer } from "@utils/redux/slices/surveyAnswers";
import i18n from "src/locales";
import { appConfig } from "src/config";

function disqualified(surveyAnswers: SurveyAnswer) {
  return surveyAnswers?.workoutPlanLimitations?.includes("painOrLosingBreath");
}

const DIETARY_RESTRICTION_OPTIONS = [
  {
    id: "lowCarbOrKeto",
    text: "Low-carb or keto (easy on the grains and starches)",
  },
  {
    id: "vegetarian",
    text: "Vegetarian (I don’t eat meat but I eat eggs or dairy)",
  },
  {
    id: "vegan",
    text: "Vegan (no animal products please!)",
  },
  {
    id: "gluten",
    text: "Gluten and/or dairy free (I avoid these common allergens)",
  },
  {
    id: "pescatarian",
    text: "Pescatarian",
  },
  {
    id: "noSeafood",
    text: "No seafood",
  },
  {
    id: "noPork",
    text: "No pork",
  },
  {
    id: "anything",
    text: "Nope (I can eat pretty much anything)",
  },
];

export const Q_MEAL_PLAN_DIETARY_RESTRICTIONS = registerQuestion({
  id: "mealPlanDietaryRestrictions",
  type: "radio",
  question: () => {
    return (
      <>
        <h1 className={questionTitle}>
          <Text i18nKey="addOnStore:consultation:premiumBundle" />
        </h1>
        <h2 className={questionTitle}>
          <Text i18nKey="addOnStore:consultation:dietaryRestrictions" />
        </h2>
      </>
    );
  },
  options: DIETARY_RESTRICTION_OPTIONS,
});

const Q_WORKOUT_PLAN_LIMITATIONS_OPTIONS = [
  {
    id: "painOrLosingBreath",
    text: "I cannot walk or be physically active for 10 minutes continuously without experiencing pain or losing my breath",
  },
  {
    id: "injuredOrRecovering",
    text: "I’m currently injured or recovering from an injury",
  },
  {
    id: "physicalTherapy",
    text: "I’m in physical or occupational therapy",
  },
  {
    id: "badJointsOrKnee",
    text: "I have bad joints and/or knee",
  },
  {
    id: "cantJump",
    text: "I can't jump up and down",
  },
  {
    id: "unableToDoCardio",
    text: "I’m unable to do intense cardio",
  },
  {
    id: "doctorRestrictions",
    text: "My doctor has placed certain restrictions on my exercise",
  },
  {
    id: "other",
    text: "Other",
  },
  {
    id: "none",
    text: "Nope, I can try most things",
  },
];

export const Q_WORKOUT_PLAN_LIMITATIONS =
  registerQuestion<CheckboxWithOtherQuestionDefinition>({
    id: "workoutPlanLimitations",
    type: "custom",
    component: CheckboxWithOtherQuestion,
    question:
      "Do you have any physical limitations or restrictions? (Select all that apply)",
    options: Q_WORKOUT_PLAN_LIMITATIONS_OPTIONS,
  });

export class DisqualifiedMessage extends Question<CustomQuestionDefinition> {
  override onMount() {
    this.props.registerAnswer({}, true);
  }

  override renderOptions() {
    return <></>;
  }

  override renderWithControls() {
    return (
      <div
        data-cy="question"
        data-cy-question={this.props.question.id}
        className={questionOptions}
      >
        <h1 className={questionTitle}>
          <Text i18nKey="addOnStore:consultation:workoutPlanNotAble" />
        </h1>
        <h2 className={questionTitle}>
          <Text
            i18nKey="addOnStore:consultation:reachOutSupport"
            components={{
              FormLink: (
                <a
                  href={`${appConfig.BLOG_DOMAIN}/support/contact-support/`}
                  target="_blank"
                  rel="noreferrer"
                />
              ),
            }}
          />
        </h2>
      </div>
    );
  }
}

export const Q_DISQUALIFIED = registerQuestion({
  id: "disqualified",
  type: "custom",
  component: DisqualifiedMessage,
  next: {
    text: i18n.t("survey:btnContinue"),
  },
  shouldShowQuestion: ({ surveyAnswers }) => {
    return disqualified(surveyAnswers);
  },
});

export const Q_WORKOUT_PLAN_FREQUENCY = registerQuestion({
  id: "workoutPlanFrequency",
  type: "radio",
  question: "How many days a week do you want to be active?",
  options: [
    {
      id: "3to4Days",
      text: "3 to 4 days per week",
    },
    {
      id: "5to6Days",
      text: "5 to 6 days per week",
    },
  ],
});

export const Q_WORKOUT_PLAN_EQUIPMENT = registerQuestion({
  id: "workoutPlanEquipment",
  type: "radio",
  question: "Do you prefer an equipment based or an equipment free program?",
  options: [
    {
      id: "equipmentBased",
      text: "Equipment based",
    },
    {
      id: "equipmentFree",
      text: "Equipment free program",
    },
  ],
});
